<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('common_setup') }}</h6>
    <div class="flex items-end gap-6">
        <!-- Grace period warning (always shown first if conditions met) -->
        <app-svg name="importantMark" [color]="ss.theme().color14" width="18" height="18"
            *ngIf="setup().uid === cc.user.uid && ss.isInGracePeriod()" role="button"
            (click)="ds.featureExpiringSoon()"></app-svg>


        <!-- Comments: edit mode, >= 375px, not deleted -->
        @if (mode() === 'edit' && !deleted() && screenWidth() >= 375) {
        <app-svg name="commonMenuComment" class="icon-mirror-rtl" (click)="openMessage()" role="button"
            [color]="ss.theme().color12" width="18" height="18"></app-svg>
        }

        <!-- Collaborators: always on top bar in new mode; edit mode only on >= 375px when collabs exist -->
        @if (!deleted() && screenWidth() >= 375) {
        <span class="collab-icon-wrapper" (click)="addCollaborator()" role="button">
            <app-svg [name]="getTopBarCollaboratorIcon()" class="icon-mirror-rtl"
                [color]="ss.theme().color12"></app-svg>
            @if (collabCount() > 0) {
            <span class="collab-badge">{{ collabCount() }}</span>
            }
        </span>
        }

        <!-- Kebab: edit mode, not deleted -->
        @if (mode() === 'edit' && !deleted()) {
        <app-svg name="topbarKebabDot" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button"
            [color]="ss.theme().color12" width="18" height="18"></app-svg>
        }

        <!-- Close: always last -->
        <app-svg name="topBarClose" role="button" (click)="closeDialog()" width="18" height="18"></app-svg>

        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu">

            <!-- Info: always in kebab -->
            <button mat-menu-item (click)="openFeatureGuide()">
                <span class="flex items-center gap-3">
                    <app-svg name="commonMenuInfo" [color]="ss.theme().color35"></app-svg>
                    <span class="text-14-400 color-8">{{ ss.t('common_info') }}</span>
                </span>
            </button>

            <!-- Collaborators: mobile (<375px) when collabs exist (overflows from top bar) -->
            @if (screenWidth() < 375 && !deleted()) { <button mat-menu-item (click)="addCollaborator()"
                class="common-menu-width">
                <span class="text-14-400 color-8 flex items-center gap-3">
                    <app-svg [name]="getCollaboratorIcon()" class="flex items-center justify-center"
                        [color]="ss.theme().color35"></app-svg>
                    {{ ss.t('common_dropdownCollaboration') }}
                </span>
                <div class="kebabmenu-add">
                    <span class="color-35 common-count">{{ collabCount() }}</span>
                </div>
                </button>
                }

                <!-- Comments: mobile only (<375px) -->
                @if (screenWidth() < 375) { <button mat-menu-item (click)="openMessage()">
                    <span class="flex items-center gap-3">
                        <app-svg name="kebabMenucomment" class="icon-mirror-rtl" [color]="ss.theme().color35"></app-svg>
                        <span class="text-14-400 color-8">{{ ss.t('comments_titleTopBar') }}</span>
                    </span>
                    </button>
                    }

                    <!-- Leave: non-owners -->
                    @if (role() !== 'owner') {
                    <button mat-menu-item (click)="removeCollab('left')">
                        <span class="flex items-center gap-3">
                            <app-svg name="leave" class="icon-mirror-rtl" [color]="ss.theme().color11"></app-svg>
                            <span class="text-14-400 color-8">{{ ss.t('common_leave') }}</span>
                        </span>
                    </button>
                    }

                    <!-- Block/Unblock: non-owners -->
                    @if (role() !== 'owner') {
                    <button mat-menu-item (click)="removeCollab('blocked')">
                        <span class="flex items-center gap-3">
                            <app-svg name="block" [color]="ss.theme().color11"></app-svg>
                            <span class="text-14-400 color-8">{{ ss.t(getBlockLabel()) }}</span>
                        </span>
                    </button>
                    }

                    <!-- Delete: owners -->
                    @if (role() === 'owner') {
                    <button mat-menu-item (click)="deleteJournalSetup()">
                        <span class="flex items-center gap-3">
                            <app-svg name="commonMenutrash" [color]="ss.theme().color11"></app-svg>
                            <span class="text-14-400 color-8">{{ ss.t('common_setupOrActionDelete') }}</span>
                        </span>
                    </button>
                    }

        </mat-menu>
    </div>
</div>
<div class="journal-setup-form">
    <app-common-setup-type featureType="journal" featureTypeContent="common_journal"
        [blocked]="deleted()"></app-common-setup-type>
    <form [formGroup]="journalSetupForm" #jSetupForm="ngForm" class="flex flex-col gap-6 p-4 journal-form">
        <app-input-text [control]="getFc('title')" name="meJournalTitle" [placeholder]="ss.t('common_titlePlaceholder')"
            maxLength="200" [submitted]="submitted" [noEnter]="true" [readonly]="role() !== 'owner'"
            [accessAlert]="true" [blocked]="deleted()"></app-input-text>
        <app-input-date-period name="meJournalDateRange" [startControl]="getFc('startDate')"
            [endControl]="getFc('endDate')" [repeatControl]="getFc('repeat')" [readonly]="role() !== 'owner'"
            [accessAlert]="true" [blocked]="deleted()" [isDelete]="true" [editAlert]="mode() === 'edit' ? true : false"
            [entityNameType]="'journal'" (cloneEvent)="cloneSetup()"></app-input-date-period>
        <app-input-time *ngIf="journalSetupForm.value.startDate" [control]="getFc('startDate')"
            [startTimeControl]="getFc('startTime')" [isTzAffected]="getFc('isTzAffected')"
            [isStartTimeSet]="getFc('isStartTimeSet')" [duration]="getFc('duration')" [reminder]="getFc('reminderAt')"
            [readonly]="role() !== 'owner'" [accessAlert]="true" [blocked]="deleted()"></app-input-time>
        <app-input-reminder [control]="getFc('reminderAt')"
            *ngIf="journalSetupForm.value.startDate && journalSetupForm.value.isStartTimeSet"
            [readonly]="role() !== 'owner'" [accessAlert]="true" [blocked]="deleted()"></app-input-reminder>
        <app-input-hashtag *ngIf="role() === 'owner'" [control]="getFc('tags')" [blocked]="deleted()"
            [accessAlert]="true" [screenWidth]="screenWidth()" [defaultTagIds]="[]"
            (tagsChanged)="onHashtagsChanged($event)" (activeChanged)="hashtagInputActive.set($event)"></app-input-hashtag>
        <p class="text-14-400 color-7 text-end" *ngIf="deleted()">{{ deletedAtString() }}</p>
    </form>

    @if (hasEntries() && !deleted()) {
    <div class="view-entries-pill-container">
        <button class="view-entries-pill" (click)="openEntities()">{{ ss.t('habit_viewEntries') }}</button>
    </div>
    }

    <!-- <pre class="color-8">{{ journalSetupForm.value | json }}</pre> -->
</div>



<div class="bottom-section flex items-center justify-between ri-p-4 text-end ri-bt-2" *ngIf="!deleted()">
    <div class="flex items-center gap-8">
        <app-svg *ngIf="role() === 'owner' && (!getFc('tags').value || getFc('tags').value.length === 0) && !hashtagInputActive()" name="hashtag" [color]="ss.theme().color35" role="button"
            (click)="activateHashtagInput()"></app-svg>
    </div>
    <button type="submit" class="btn-text text-16-500 color-35" (click)="hasChanges() ? save() : closeDialog()">{{
        hasChanges() ? ss.t('common_save') : ss.t('common_close') }}</button>
</div>
<div class="bottom-section flex items-center justify-around ri-bt-2 ri-py-4" *ngIf="deleted()">
    <button class="btn-text text-16-400 color-11 ri-px-8" (click)="remove()">{{
        ss.t('common_buttonRemove') }}</button>
    <button class="btn-text text-14-400 color-35 ri-px-8" (click)="restore()">{{
        ss.t('common_restore') }}</button>
</div>